import Category from "../../../models/Category";
import { normalizeString } from "../../utils";

export const getId = (state: Category) => {
  return state.id;
};

export const getName = (state: Category) => {
  return state.text;
};

export const getTagIds = (state: Category) => {
  return state.tagIds;
};

export const isHidden = (state: Category) => {
  return state.details && state.details.get("hidden");
};

export const getDetails = (state: Category) => {
  return state.details;
};

export const hasLegacyName = (state: Category, categoryName: string) => {
  const legacyNames = (state.details && state.details.get("legacyNames")) || [];
  return (
    legacyNames
      // @ts-ignore
      .map(name => normalizeString(name))
      .includes(normalizeString(categoryName))
  );
};

export const getSemanticCategory = (state: Category) => {
  return state.semanticCategory;
};
